import { render } from "./skillsForm.vue?vue&type=template&id=2bba7a70&scoped=true"
import script from "./skillsForm.vue?vue&type=script&lang=js"
export * from "./skillsForm.vue?vue&type=script&lang=js"

import "./skillsForm.vue?vue&type=style&index=0&id=2bba7a70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bba7a70"]])

export default __exports__